import { useMutation, useQuery, UseQueryOptions } from "react-query";
import { CustomerLog, GameSession, GameSessionPage } from "src/types";
import { api } from "src/utils";

export interface UseCustomerGameSessionsFilters {
  skip?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
  gameProviders?: string[];
}

export function useCustomerGameSessions(
  customerCode: string,
  filters?: UseCustomerGameSessionsFilters,
  options?: UseQueryOptions<GameSessionPage, unknown, GameSessionPage, any[]>
) {
  return useQuery(
    ["customerGameSessions", customerCode, filters],
    async () => {
      const response = await api.get(`payment/customer/${customerCode}/game-sessions`, {
        params: filters,
      });
      return response.data.data;
    },
    options
  );
}

export function useGameSessionRounds(
  customerCode: string,
  session?: GameSession,
  options?: UseQueryOptions<CustomerLog[], unknown, CustomerLog[], any[]>
) {
  return useQuery(
    ["gameSessionRounds", customerCode, session?.gameProvider, session?.gameName, session?.betTransactionRefId,
      session?.parentBetId, session?.startedAt, session?.lastRoundAt],
    async () => {
      const response = await api.get(`payment/customer/${customerCode}/game-sessions/rounds`, {
        params: {
          gameProvider: session?.gameProvider,
          gameName: session?.betTransactionRefId ? undefined : session?.gameName,
          betTransactionRefId: session?.betTransactionRefId,
          parentBetId: session?.betTransactionRefId ? session?.parentBetId : undefined,
          startedAt: session?.startedAt,
          lastRoundAt: session?.lastRoundAt,
        },
      });
      return response.data.data.results;
    },
    { enabled: Boolean(customerCode && session), ...options }
  );
}

/** Asks wallet to prepare the customer's play sessions in the background when support searches them, so the
 * "รอบการเล่นรายเกม" tab is usually ready by the time it is opened. Best effort: errors are ignored. */
export function usePrepareGameSessions() {
  return useMutation((customerCode: string) =>
    api.post(`payment/customer/${customerCode}/game-sessions/prepare`).catch(() => undefined)
  );
}
